import { useLang } from "../i18n/LangContext";
import { COMPANY, IUBENDA } from "../constants/legal";

export const Footer = () => {
  const { t, lang, setLang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0e3d44] text-[#F1EEE8] border-t border-[#F1EEE8]/10" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <img
              src="/brand/zitro-logo-white.png"
              alt="Zitro Property Management"
              className="h-24 md:h-32 w-auto object-contain select-none"
              draggable="false"
            />
            {t.footer.motto && (
              <div className="mt-6 italic-serif text-[#B08F5C] text-lg md:text-xl">
                &ldquo;{t.footer.motto}&rdquo;
              </div>
            )}
          </div>
          <div className="md:col-span-3">
            <div className="text-[0.68rem] tracking-[0.28em] uppercase text-[#F1EEE8]/45 mb-5 font-medium">
              Nav
            </div>
            <ul className="space-y-3 text-[#F1EEE8]/80">
              {[
                { href: "#about", label: t.nav.about },
                { href: "#services", label: t.nav.services },
                { href: "#portfolio", label: t.nav.portfolio },
                { href: "#insights", label: t.nav.insights },
                { href: "#contact", label: t.nav.contact },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="link-underline">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="text-[0.68rem] tracking-[0.28em] uppercase text-[#F1EEE8]/45 mb-5 font-medium">
              {t.footer.lang}
            </div>
            <div className="flex gap-3 text-sm tracking-[0.22em] flex-wrap">
              {["it","en","de","fr","ru"].map((code, i) => (
                <span key={code} className="flex items-center gap-3">
                  {i > 0 && <span className="opacity-30">/</span>}
                  <button onClick={() => setLang(code)} className={lang === code ? "" : "opacity-40 hover:opacity-70"}>{code.toUpperCase()}</button>
                </span>
              ))}
            </div>

            <div className="mt-10 text-[0.68rem] tracking-[0.28em] uppercase text-[#F1EEE8]/45 mb-3 font-medium">
              {t.contact.infoTitle}
            </div>
            <div className="text-[#F1EEE8]/75 text-sm leading-relaxed space-y-2">
              <div className="whitespace-pre-line">{t.contact.infoAddress}</div>
              <div>
                <a href={`mailto:${t.contact.infoEmail}`} className="link-underline">
                  {t.contact.infoEmail}
                </a>
              </div>
              <div>
                <a href={`tel:${t.contact.infoPhone.replace(/\s/g, "")}`} className="link-underline">
                  {t.contact.infoPhone}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F1EEE8]/12 flex flex-col gap-6 text-[#F1EEE8]/45 text-[0.68rem] tracking-[0.22em] uppercase">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a href={IUBENDA.privacyUrl} target="_blank" rel="noreferrer" className="link-underline hover:text-[#F1EEE8]/80 transition-colors">
              Privacy Policy
            </a>
            <a href={IUBENDA.cookieUrl} target="_blank" rel="noreferrer" className="link-underline hover:text-[#F1EEE8]/80 transition-colors">
              Cookie Policy
            </a>
            <button type="button" className="iubenda-cs-preferences-link link-underline hover:text-[#F1EEE8]/80 transition-colors uppercase tracking-[0.22em]">
              Preferenze Cookie
            </button>
          </div>
          <div className="flex flex-col md:flex-row justify-between gap-4">
            <div>© {year} {COMPANY.brand}. {t.footer.rights}</div>
            <div>{COMPANY.legalName} · P.IVA {COMPANY.vat} · {COMPANY.address}</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
